module.exports = __webpack_public_path__ + "static/img/ctyiyuan2.ad16f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ctimaging/ctyiyuan2.png
// module id = QJ6n
// module chunks = 5